export enum UrlParamTypes {
  TOKEN = 'token',
  RESET_TOKEN = 'resetToken',
  TARGET = 'target',
}
